.integrationModal {
	.content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0px;
		color: #6c757d;

		&.inProcess {
			font-weight: 500;
			color: #7fb02f;
		}

		&.complete {
			font-weight: 500;
			color: black;
		}

		.checkIcon {
			width: 1.5em;
			height: 1.5em;
		}

		.successIcon {
			color: #1f9d55;
		}

		.errorIcon {
			color: #dc2626;
		}
	}
}
